<template>
  <div class="pp-post-layer-body">
    <p>Any questions about orders sync, courier matching or tracking update?</p>
  </div>
</template>

<script>
export default {
  name: "OrderMessagePost"
}
</script>

<style scoped>
</style>